import FormationDetails from "components/FormationDetails";

const PreviewContainer = () => {
    return <FormationDetails />;
};

export default PreviewContainer;
